import { render, staticRenderFns } from "./MainSample.vue?vue&type=template&id=22b0fb28&"
import script from "./MainSample.vue?vue&type=script&lang=js&"
export * from "./MainSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports